import { SelectableDisabledTransaction } from './selectable-disabled-transaction';

export class StudyTransaction extends SelectableDisabledTransaction {}
